import { AfterViewChecked, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ComboNgSelect } from '../../../core/model/combos';
import { Cliente } from '../../../core/model/cliente';
import { UsuarioCliente } from '../../../core/model/usuario-cliente';
import { TemplatesService } from '../../../core/services/templates.service';
import { DepartamentosSeriesService } from '../../../core/services/departamentos-series.service';
import { ClientesService } from '../../../core/services/clientes.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap';
import { UsersService } from '../../../core/services/users.service';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';
import { SeriesService } from '../../../core/services/series.service';
import { SessionService } from '../../../core/services/session.service';
import { DepartamentoSerie } from '../../../core/model/departamento-serie';
import { first } from 'rxjs/internal/operators/first';
import { ExpedienteFiltroDTO, FullTextHojas } from '../../../core/model/inventories';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ExtraerSeriesAlmacen } from '../../../core/model/extraser-series-almacen';
import { InventariosService } from '../../../core/services/inventarios.service';
import { CamposPlantillaComponent } from '../../formulario-plantilla/campos-plantilla/campos-plantilla.component';
import { RangoSimple } from '../../../core/model/Rangos';
import { ContadorContenidos, DataReturnsSelected } from '../../../core/model/detalle-solicitud';
import { FiltroDevolucion } from '../../../core/model/filtro-devolucion';
import { FileData } from '../../../core/model/massive-load-result';
import { UnidadSolicitud } from '../../../core/model/unidad-solicitud';
import { TemplateField } from '../../../core/model/template-field';
import { SpecialFormValidators } from '../../../core/model/specialFormValidators';
import { CampoSolicitud } from '../../../core/model/campo-solicitud';
import { constant, result } from 'lodash';
import { CargaMasivaService } from '../../../core/services/carga-masiva.service';
import { DatePipe, formatDate } from '@angular/common';
import { stringify } from 'querystring';
import { ResponseFechas } from '../../../core/model/response-fechas';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-extraer-inventarios',
  templateUrl: './extraer-inventarios.component.html',
  styleUrls: ['./extraer-inventarios.component.css']
})
export class ExtraerInventariosComponent
  implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('camposss') camposPlantillaComponent: CamposPlantillaComponent;

  
  @Input() tipoSolicitud: string;
  @Input() clientIdSelected = 0;
  @Input() hasShowClientUsers = true;
  @Input() hasFindFields = true;
  @Input() isDevolucionByData = false;
  
  @Input() busquedaInventario = true;
  @Input() fixed: boolean;
  @Input() cargaMasiva: boolean;
  @Input() maxContenidos: number;
    
  @Input() set dataSelected(data: DataReturnsSelected) {
    this.hasHideMainData = data.needDataToShowData;
    if (data.serieId) {
      this.cliente = data.clientSelected;
      this.usuarioSeleccionado = data.userSelected;
      this.serie = data.serieId;
      this.getCampos();
    } else {
      this.campos = [];
      this.camposSencillos = [];
      this.camposRangoNombres = [];
    }
  }

  @Output() nuevaUnidad = new EventEmitter();
  @Output() valoresEstablecidos = new EventEmitter();
  @Output() camposEstablecidos = new EventEmitter();
  @Output() serieEstablecida = new EventEmitter();
  @Output() clienteUsuarioEstablecido = new EventEmitter();
  @Output() contadorPrestamos = new EventEmitter<ContadorContenidos>();
  @Output() filtroDevoluciones = new EventEmitter<FiltroDevolucion>();
  @Output() newFileUploaded = new EventEmitter<FileData>();
  @Output() unidadEditada = new EventEmitter<UnidadSolicitud>();
  @Output() cargandoDevoluciones = new EventEmitter<boolean>();
  @Output() hasFieldsRangeInSearch = new EventEmitter<boolean>();
  @Output() documentationFiles = new EventEmitter<FileData[]>();
  @Output() isFormGroupValid = new EventEmitter<boolean>();
  @Output() resetUnitDevoluciones = new EventEmitter<boolean>();

  cliente = undefined;

  seriesCombo: ComboNgSelect[] = undefined;
  serie: number = undefined;

  departamentosSeries = new Map<number, any>();
  departamento = undefined;
  departamentosCombo: ComboNgSelect[] = undefined;

  usuarioSeleccionado = undefined;
  departamentos: number[] = [];
  clientes: Cliente[] = [];
  usuarios: UsuarioCliente[] = [];
  
  showError = false;
  loading = false;
  loadingExtraer = false;
  isDocoutUser = false;
  isSupervisor = false;
  isAdmin = false;

  _isPrestamoInventario: boolean;
  hasToSelectUser = false;
  showDocumentacionSolicitud = false;

  filtro = new ExpedienteFiltroDTO();
  formGroup: FormGroup;

  public campos: TemplateField[] = undefined;
  public camposSencillos: TemplateField[] = [];

  hasHideMainData: boolean;
  azInventoryLevel = false;
  serieValida = false;
  isFormValid = false;
  camposRangoSimple = new Map<string, RangoSimple>();
  camposRangoNombres: string[] = [];

  camposRango = new Map<
    string,
    { desde: TemplateField; hasta: TemplateField }
    >();
  
  busquedaExtraerDatosSeriesAlmacen = true;

  camposSolicitudBusqueda: CampoSolicitud[];
  nombreSerieExtraerSeries: string;
  nombreFicheroInforme: string;
  errorMensaje: string;
  camposBusquedaVacios = false;

  fechaDesdeSeleccionada: Date;
  fechaHastaSeleccionada: Date;
  datosFechas: ResponseFechas;

  saltarFiltroSerie = false;

  rootParent: string;
  rootChild: string;
  title: string;
  description: string;

  constructor(
    private templatesService: TemplatesService,
    private departamentosSeriesService: DepartamentosSeriesService,
    private localeService: BsLocaleService,
    private clientesService: ClientesService,
    private authService: AuthenticationService,
    private usersService: UsersService,
    private toastrService: ToastrService,
    private utilsService: UtilitiesService,
    private seriesService: SeriesService,
    private sessionService: SessionService,
    private inventarioService: InventariosService,
    private datePipe: DatePipe,
    private translateService: TranslateService
  ) { 

    this.authService.getClienteName$().subscribe(beadcrumbDad => {
      this.rootParent = beadcrumbDad;
    });

    this.title = this.translateService.instant('informes.informe');
    this.description = this.translateService.instant('informes.informeCliente');
    this.rootChild = this.translateService.instant('informes.informe');


  }

  ngOnInit() {
    this.cliente = undefined;
    this.usuarioSeleccionado = undefined;
    this.usuarios = [];
    this.departamento = undefined;
    this.serie = undefined;
    this.showError = false;
    this.filtro.VALORES = undefined;

    this.clientesService.getAllClientes().subscribe((clientes: Cliente[]) => {
      this.clientes = clientes.sort(function (a, b) {
        if (a.NOMBRE < b.NOMBRE) { return -1; }
        if (a.NOMBRE > b.NOMBRE) { return 1; }
        return 0;
      });
      if (
        this._isPrestamoInventario &&
        this.clientIdSelected != 0 &&
        this.clientes.some(x => x.ID == this.clientIdSelected)
      ) {
        this.cliente = this.clientIdSelected;
        this.hasToSelectUser = true;
        this.hasShowClientUsers = true;
        this.procesarClienteSeleccionado();
      }
      if (this.clientes.length == 1) {
        this.clientIdSelected = this.clientes[0].ID;
        this.cliente = this.clientes[0];
        this.procesarClienteSeleccionado();
      }
    });
  }

  procesarUsuarioSeleccionado() {
    this.departamento = undefined;
    this.serie = undefined;
    this.serieEstablecida.emit(undefined);
    this.departamentosSeries.clear();
    this.departamentos = [];
    if (!this.usuarioSeleccionado) {
      if (this.isSupervisor && this.tipoSolicitud === 'devolucion') {
        this.getDepartamentosSeries();
      }
    }
    if (this.usuarioSeleccionado) {
      this.getDepartamentosSeries();
    }
    this.clienteUsuarioEstablecido.emit({
      cliente: this.cliente,
      usuario: this.usuarioSeleccionado
    });
  }


  procesarClienteSeleccionado() {
    this.departamento = undefined;
    this.serie = undefined;
    this.serieEstablecida.emit(undefined);
    this.usuarioSeleccionado = undefined;

    if (!this.cliente) {
      this.usuarios = [];
      this.departamentosSeries.clear();
      this.departamentos = [];
      this.showDocumentacionSolicitud = false;
    } else if (this.isServiceToAttachFiles()) {
      this.showDocumentacionSolicitud = this.clientes.find(
        cli => cli.ID == this.cliente
      ).DocumentacionSolicitudes;
    }

    if (this.cliente) {
      //if (this.hasShowClientUsers) {
      //  this.getUsersByClient(this.cliente);
      //} else {
        this.getDepartamentosSeries();
        this.clienteUsuarioEstablecido.emit({ cliente: this.cliente });
      //}
    }
  }

  getSeriesforSelectedDepartment() {
    if (
      this.departamentosSeries &&
      this.departamentosSeries.get(+this.departamento)
    ) {
      const auxComboSeries = this.departamentosSeries
        .get(+this.departamento)
        .series.map(serie => {
          const serieCombo = new ComboNgSelect();
          serieCombo.ID = serie.idSerie;
          serieCombo.NOMBRE = serie.nombreSerie;
          return serieCombo;
        });
      this.seriesCombo = [...auxComboSeries];
      if (this.seriesCombo.length == 1) {
        this.serie = this.seriesCombo[0].ID;
        this.getOficinas();
      }
    }
  }

  getOficinas() {
    
  }

  private isServiceToAttachFiles() {
    return (
      this.tipoSolicitud === 'prestamos' ||
      this.tipoSolicitud === 'recogida' ||
      this.tipoSolicitud === 'entrega'
    );
  }

  private getUsersByClient(client: number) {
    this.usersService
      .getUsersByClient(client)
      .subscribe((users: UsuarioCliente[]) => {
        if (this.isSupervisor && this.tipoSolicitud !== 'devolucion') {
          this.usuarioSeleccionado = this.authService.getUserId();
        }
        this.usuarios = users;
      });
  }

  getDepartamentosSeries() {
    this.departamentosSeries.clear();
    this.departamentos = [];

    const clienteId = this.isDocoutUser
      ? this.cliente
      : this.sessionService.getClientId();

    this.departamentosSeriesService
      .getDepartamentosSeriesByClient(clienteId, this.usuarioSeleccionado)
      .pipe(first())
      .subscribe((departamentosSeries: DepartamentoSerie[]) => {
        departamentosSeries.forEach((departamentoSerie: DepartamentoSerie) => {
          if (!this.departamentosSeries.has(departamentoSerie.idDepartamento)) {
            this.departamentosSeries.set(departamentoSerie.idDepartamento, {
              nombre: departamentoSerie.nombreDepartamento,
              series: []
            });
            this.departamentos.push(departamentoSerie.idDepartamento);
          }
          if (
            this.departamentosSeries
              .get(departamentoSerie.idDepartamento)
              .series.filter(
                serie => serie.idSerie === departamentoSerie.idSerie
              ).length === 0
          ) {
            this.departamentosSeries
              .get(departamentoSerie.idDepartamento)
              .series.push({
                idSerie: departamentoSerie.idSerie,
                nombreSerie: departamentoSerie.nombreSerie
              });
          }
        });

        this.departamentosCombo = this.getDepartamentosCombo(
          this.departamentosSeries
        );
        if (this.departamentosSeries.size === 1) {
          this.departamento = this.departamentosSeries.keys().next().value;
          this.seriesCombo = this.getSeriesCombo(
            this.departamentosSeries.get(this.departamento).series
          );
          if (
            this.departamentosSeries.get(this.departamento).series.length === 1
          ) {
            this.serie = this.departamentosSeries.get(
              this.departamento
            ).series[0].idSerie;
          }
        }
      });
  }

  private getDepartamentosCombo(
    departamentosSeries: Map<number, any>
  ): ComboNgSelect[] {
    const comboDepartamentos = [];
    departamentosSeries.forEach((value: any, key: number) => {
      const departamentoCombo = new ComboNgSelect();
      departamentoCombo.ID = key;
      departamentoCombo.NOMBRE = value.nombre;
      comboDepartamentos.push(departamentoCombo);
      if (this.departamento == key) {
        this.seriesCombo = this.getSeriesCombo(value.series);
      }
    });
    this.departamentosCombo = [...comboDepartamentos];
    return this.departamentosCombo.sort(function (a, b) {
      return a == b ? 0 : b > a ? -1 : 1;
    });
  }

  private getSeriesCombo(series: any[]): ComboNgSelect[] {
    const comboSeries = [];
    series.map(serie => {
      const serieCombo = new ComboNgSelect();
      serieCombo.ID = serie.idSerie;
      serieCombo.NOMBRE = serie.nombreSerie;
      comboSeries.push(serieCombo);
    });
    this.seriesCombo = [...comboSeries];
    return this.seriesCombo;
  }

  getCampos() {
    this.formGroup = undefined;
    if (!!this.serie) {
      this.seriesService
        .getSerieById(this.serie)
        .pipe(first())
        .subscribe(
          result => (this.azInventoryLevel = result.inventoryLevelId === 2)
          ,
          error => (this.azInventoryLevel = false)
      );
      this.campos = [];
      this.camposSencillos = [];
      if (!this.hasHideMainData) {
        this.serieEstablecida.emit(this.serie);
      }
      if (this.hasFindFields) {
        this.loadingExtraer = true;
        this.inventarioService
          .getExtraerSeriesFields(this.serie)
          .pipe(first())
          .subscribe(
            (camposRecuperados: ExtraerSeriesAlmacen[]) => {
              if (camposRecuperados === null) {
                this.toastrService.warning(
                  'La serie seleccionada no tiene campos para la búsqueda en los inventarios de almacén.',
                  'Serie no válida'
                );
                this.serieValida = false;
                this.loadingExtraer = false;
                return;
              }
              //this.templateId = plantilla.idPlantilla;
              this.serieValida = true;
              camposRecuperados.forEach((campoRecorrer: ExtraerSeriesAlmacen) => {
                const nuevoCampo = TemplateField.toModel(JSON.stringify(campoRecorrer.Campo));   

                //this.campos.push( campoRecorrer.Campo);
                this.campos.push(nuevoCampo);
              });
              
              this.camposSencillos = this.busquedaInventario
                ? this.campos.filter(
                    c => !c.rango && c.subtipo !== 'RANGO_SIMPLE'
                  )
                : this.campos;
              const group = {};
              this.camposRango.clear();
              this.camposRangoNombres = [];
              this.campos.forEach((campo: TemplateField) => {
                this.proccessFieldsRange(campo);
                if (campo.VALOR_PORDEFECTO !== null && campo.VALOR_PORDEFECTO !== undefined) {
                  campo.value = campo.VALOR_PORDEFECTO;
                }
                const control = new FormControl(campo.value);
                const validators = [];
                if (campo.obligatorio && !this.busquedaInventario) {
                  validators.push(Validators.required);
                }
                if (campo.subtipo && campo.subtipo.startsWith('VALIDACION')) {
                  const validator = this.getValidationError(campo.subtipo);
                  if (validator) {
                    validators.push(validator);
                  }
                }
                if (campo.max) {
                  validators.push(Validators.maxLength(campo.max));
                }
                if (campo.min) {
                  validators.push(Validators.minLength(campo.min));
                }
                control.setValidators(validators);
                group[campo.nombre] = control;
              });
              /*if (this.addIdContenido)
                group['idcontenido'] = new FormControl('');*/
              this.formGroup = new FormGroup(group);
              this.isFormValid = this.formGroup.valid;
              this.isFormGroupValid.emit(this.isFormValid);
              this.loadingExtraer = false;
              this.camposEstablecidos.emit(this.campos);
              /*if (
                this.tipoSolicitud === 'devolucion' &&
                !this.hasHideMainData
              ) {
                this.buscarPrestamos();
              }*/
            },
            error => {
              this.toastrService.warning(
                'No se han podido recuperar los campos para filtrar la búsqueda de la serie en Almacén.' 
              );
              this.loadingExtraer = false;
              this.camposEstablecidos.emit([]);
            }
          );
      }
    } else {
      this.serieEstablecida.emit(null);
    }
  }
  
  setSerie(serie: any) {
    this.filtro.ID_SERIE = parseInt(serie, 10);
  }

  setClientSelected(event) {
    if (event.cliente === 0) {
      this.filtro.ID_SERIE = undefined;
    }
    this.filtro.ID_CLIENTE = parseInt(event.cliente, 10);
  }

  getValidationError(subtipo: string): any {
    const typeValidation = subtipo.substr('VALIDACION.'.length);
    if (typeValidation === 'NIF') {
      return SpecialFormValidators.validateNIF;
    }
    if (typeValidation === 'CIF') {
      return SpecialFormValidators.validateCIF;
    }
    if (typeValidation == 'CUPS') {
      return SpecialFormValidators.validateCUPS;
    }
    if (typeValidation == 'IBAN') {
      return SpecialFormValidators.validateIBAN;
    }
    return null;
  }
  
  private proccessFieldsRange(campo: TemplateField) {
    if (campo.rango && this.busquedaInventario) {
      const aux = this.camposRango.get(campo.descripcion) || {
        desde: undefined,
        hasta: undefined
      };
      if (campo.rango === 1) {
        aux.desde = campo;
      }
      if (campo.rango === 2) {
        aux.hasta = campo;
      }
      this.camposRango.set(campo.descripcion, aux);

      if (this.camposRangoNombres.indexOf(campo.descripcion) < 0) {
        this.camposRangoNombres.push(campo.descripcion);
      }
    }
    if (campo.subtipo === 'RANGO_SIMPLE') {
      const aux = CamposPlantillaComponent.createRangoSimple(campo);
      this.camposRangoSimple.set(campo.descripcion, aux);
    }
  }

  private getValueCampoRangoSimple(name) {
    const campoRangoSimple: RangoSimple = this.camposRangoSimple.get(name);
    if (!!campoRangoSimple.desde && !!campoRangoSimple.desde.value) {
      const value = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.desde.value.toLocaleString()
        : campoRangoSimple.desde.value;
      return value + 'gt';
    }
    if (!!campoRangoSimple.hasta && !!campoRangoSimple.hasta.value) {
      const value = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.hasta.value.toLocaleString()
        : campoRangoSimple.hasta.value;
      return value + 'lt';
    }
    if (!!campoRangoSimple.igual && !!campoRangoSimple.igual.value) {
      const value = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.igual.value.toLocaleString()
        : campoRangoSimple.igual.value;
      return value + 'eq';
    }
    if (!!campoRangoSimple.entre) {
      const valueDesde = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.entre.desde.value.toLocaleString()
        : campoRangoSimple.entre.desde.value;
      const valueHasta = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.entre.hasta.value.toLocaleString()
        : campoRangoSimple.entre.hasta.value;
      return (
        valueDesde +
        '#.o' +
        valueHasta +
        'en'
      );
    }
    return undefined;
  }

  addUnidad() {
    if (this.formGroup.valid) {
      this.showError = false;
      const unidad = new UnidadSolicitud();
      this.campos.forEach((campo: TemplateField) => {
        const campoUnidad = new CampoSolicitud();
        campoUnidad.id = campo.id;
        campoUnidad.nombre = campo.nombre;
        campoUnidad.descripcion = campo.descripcion;
        if (campo.subtipo === 'RANGO_SIMPLE') {
          campoUnidad.valor = this.getValueCampoRangoSimple(campo.descripcion);
        } else if (
          campo.tipo === 'ARRAY' &&
          campo.subtipo !== 'BIGDATA' &&
          campo.multivalue
        ) {
          campoUnidad.valor =
            !campo.value || [].concat(campo.value).length === 0
              ? []
              : [].concat(campo.value);
        } else if (
          campo.tipo === 'ARRAY' &&
          campo.subtipo !== 'BIGDATA' &&
          this.busquedaInventario
        ) {
          const value = campo.defaultValues.find(
            defaultValue => defaultValue.id == this.formGroup.controls[campo.nombre].value
          );
          campoUnidad.valor = !!value ? value.valor : null;
        } else {
          campoUnidad.valor = campo.value;
        }
        campoUnidad.multivalue = campo.multivalue;
        campoUnidad.tipo = campo.tipo;
        unidad.campos.push(campoUnidad);
      });

      this.notificarCamposDeRangoConValor();

      this.camposSolicitudBusqueda = [];

      unidad.campos.forEach((CampoSolicitud: CampoSolicitud) => {

        this.camposSolicitudBusqueda.push(CampoSolicitud);
          
      });
      
      this.nombreFicheroInforme = '';
      this.errorMensaje = '';
      this.loadingExtraer = true;
      this.camposBusquedaVacios = false;

      this.camposSolicitudBusqueda.forEach((campoRevisado: CampoSolicitud) => {
        if (campoRevisado.valor)
          this.camposBusquedaVacios = true;
      });

      if (this.camposBusquedaVacios == false)
      {
        this.toastrService.warning('Al menos un campo de búsqueda tiene que ester cumplimentado.');
        this.loadingExtraer = false;
      }
      else
      this.inventarioService.postExtraerSeriesDatosEncontrados(this.serie, this.saltarFiltroSerie, this.camposSolicitudBusqueda).subscribe(result => {

        this.inventarioService.getnombreInformeExtraerSeriesDatosEncontrados(this.serie)
          .subscribe(
            (resultNombre) => {
              if (!resultNombre)
                this.toastrService.error('No se ha podido recuperar de forma correcta el nombre del fichero para el informe.')
              else {
                this.utilsService.downloadGenericFile(resultNombre, result);
                this.toastrService.success(
                  'Excel generado de forma satisfactoria. Mire en su carpeta Descargas'
                );
                this.saltarFiltroSerie = false;
                this.loadingExtraer = false;
              }

            },
            (error) => {
              this.errorMensaje = error.message;
              this.toastrService.error('Problemas a la hora de recuperar el nombre para generar el fichero.' );
              this.loadingExtraer = false;
            } 
        );
      }
        ,
        (error) => {
          this.errorMensaje = error.message;
          this.toastrService.error('Problemas a la hora de generar la extración.');
          this.loadingExtraer = false;
        }
      );

      
    }
  }

  private notificarCamposDeRangoConValor() {
    let hasCamposRango = false;

    this.camposRango.forEach(
      (value: { desde: TemplateField; hasta: TemplateField }, key: string) => {
        if (!!value.desde.value || !!value.hasta.value) {
          hasCamposRango = true;
          return;
        }
      }
    );

    this.hasFieldsRangeInSearch.emit(hasCamposRango);
  }

  ngOnDestroy() {
    if (this.camposPlantillaComponent) {
      this.camposPlantillaComponent.ngOnDestroy();
    }
    this.showDocumentacionSolicitud = false;
  }

  ngAfterViewChecked() {
  }

  generarInformeClienteCaixa() {

    if (this.fechaHastaSeleccionada < this.fechaDesdeSeleccionada)
    {
      this.toastrService.warning('El campo de fecha HASTA no puede ser inferior al campo DESDE');
    } 
    else
    {
      let diferencia = this.fechaHastaSeleccionada.getTime() - this.fechaDesdeSeleccionada.getTime();
      let diasDeDiferencia = diferencia / 1000 / 60 / 60 / 24;

      if (diasDeDiferencia > 61)
      {
        this.toastrService.warning('El rango de fechas no puede superior a 61 días.');
      }
      else
      {

        this.loading = true;

        let fechaHastaNombre = this.datePipe.transform(this.fechaHastaSeleccionada, 'ddMMyyyy');
        let fechaDesdeNombre = this.datePipe.transform(this.fechaDesdeSeleccionada, 'ddMMyyyy');

        this.datosFechas = new ResponseFechas(this.fechaDesdeSeleccionada, this.fechaHastaSeleccionada);

        this.inventarioService.postExtraerInformeClienteCaixaEspecifico(this.datosFechas).subscribe(resultadoGeneralInforme => {

          this.utilsService.downloadGenericFile('InformeConsultas_' + fechaDesdeNombre + '_' + fechaHastaNombre + '.xlsx', resultadoGeneralInforme);

          this.toastrService.success(
            'Excel generado de forma satisfactoria. Mire en su carpeta Descargas'
          );

          this.fechaHastaSeleccionada = null;
          this.fechaDesdeSeleccionada = null;
          this.datosFechas = null;
          this.loading = false;
        },
          (error) => {
            this.errorMensaje = error.message;
            this.toastrService.error('Problemas a la hora de generar el informe de cliente.');
            this.loading = false;
          }
        );
      }
      
    }
    
  }
}
